import script from "./HeroBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroBanner.vue?vue&type=script&setup=true&lang=js"

import "./HeroBanner.vue?vue&type=style&index=0&id=2a641ac4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a641ac4"]])

export default __exports__